import React, { useState, useEffect } from "react";
import { Table, Button, Image } from "react-bootstrap";
import BasicPagination from "../../../../Pagination/Pagination";
import { getUserActivity } from "../../../../../store/actions/SuperAdminVUserViewActivity/userViewsActivity";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import moment from "moment";
import isEmpty from "../../../../../store/validation/is-Empty";
import NoContent from "../../../../reusableComponents/NoContentComponent";

const UserFavoritesEvents = (props) => {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [sort, setSort] = useState("");

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const onSuccesGetEvents = () => {
    setLoading(false);
  };
  const onErrorrGetEvents = () => {
    setLoading(false);
  };

  useEffect(() => {
    if (!isEmpty(props.dateQuery)) {
      setLoading(true);
      let query = { ...props?.dateQuery, type: 3, reportType: "ACTIVITY" };
      props.getUserActivity(query, onSuccesGetEvents, onErrorrGetEvents);
    }
  }, [props.dateQuery]);

  const [events, setEvents] = useState([]);

  useEffect(() => {
    if (!isEmpty(props.userEventActivity)) {
      const items = props.userEventActivity?.data;
      setEvents(items);
    }
  }, [props.userEventActivity]);
  

  useEffect(() => {
    if (!isEmpty(props.sortValue)) {
      setSort(props.sortValue);
    }
  }, [props.sortValue]);

  let filterData = [];
  if (sort === "A-Z") {
    filterData = events.sort((a, b) => {
      if (a?.restaurant_id?.restaurant_name < b?.restaurant_id?.restaurant_name)
        return -1;
      if (a?.restaurant_id?.restaurant_name > b?.restaurant_id?.restaurant_name)
        return 1;
      return 0;
    });
  } else if (sort === "Z-A") {
    filterData = events.sort((a, b) => {
      if (a?.restaurant_id?.restaurant_name < b?.restaurant_id?.restaurant_name)
        return 1;
      if (a?.restaurant_id?.restaurant_name > b?.restaurant_id?.restaurant_name)
        return -1;
      return 0;
    });
  }
  if (props.search) {
    let search = new RegExp(props.search, "i");
    filterData = events.filter((getall) => {
      if (
        search.test(getall?.restaurant_id?.restaurant_name) ||
        search.test(getall?.event_id?.name) ||
        search.test(getall?.user_id?.first_name) ||
        search.test(getall?.user_id?.last_name)
      ) {
        return getall;
      } else {
        return false;
      }
    });
  } else {
    filterData = events;
  }

  if (props?.filterOption === 0) {
    filterData = events.filter((data) => data?.offer_id?.isOnline);
  } else if (props?.filterOption === 1) {
    filterData = events.filter((data) => !data?.offer_id?.isOnline);
  }

  return (
    <React.Fragment>
      {!loading ? (
        <>
          <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
            <Table className="HideShowTable enMinWidth900">
              <thead>
                <tr className="super_admin_all_users_table_head">
                  <th style={{ width: "15%" }}>Event ID</th>
                  <th style={{ width: "20%" }}>Event Name</th>
                  <th style={{ width: "15%" }}>User Name</th>
                  <th style={{ width: "15%" }}>Date - Time</th>
                  <th style={{ width: "15%" }}>Viewed</th>
                  <th style={{ width: "15%" }}>Used</th>
                  <th style={{ width: "15%" }}>Restaurant</th>
                </tr>
              </thead>

              {filterData.length ?
                filterData.slice(start, end).map((event, index) => (
                  <tbody key={index}>
                    <tr className="enUserFavoritesTableBody">
                      <td style={{ width: "15%" }}>
                        <p className="f10-500 mt-2 mb-0">
                          {" "}
                          {event.event_id?.event_id}
                        </p>
                      </td>
                      <td style={{ width: "20%" }}>
                        <div className="d-flex align-items-center">
                          <div className="text-center d-flex flex-column align-items-center">
                            {event.event_id?.photos[0] ? (
                              <Image
                                src={
                                  event.event_id?.photo_thumbnails[0] ||
                                  event.event_id?.photos[0]
                                }
                                alt="Event image"
                                title="Event image"
                                fluid
                              />
                            ) : (
                              <Image
                                src={require("../../../../../assets/images/UserManagement/offer.png")}
                                alt="Event image"
                                title="Event image"
                                fluid
                              />
                            )}
                            <div className="enPendingLBL mt-2">
                              {event?.event_id?.isOnline ? "Online" : "Offline"}
                            </div>
                          </div>
                          <div className="pl-3">
                            <div className="f14-500">
                              {event.event_id?.name}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td style={{ width: "15%" }}>
                        <div className="col-12 p-0 d-flex align-items-center">
                          <div className="f12-500">
                            {" "}
                            {event.user_id?.first_name || ""}{" "}
                            {event.user_id?.last_name || ""}
                          </div>
                        </div>
                      </td>
                      <td style={{ width: "15%" }}>
                        <div className="f14-500">
                          {" "}
                          {moment(event.createdAt).format("DD/MM/YYYY")}
                        </div>
                        <div className="f14-500">
                          {moment(event.createdAt).format("LT")}
                        </div>
                      </td>
                      <td style={{ width: "15%" }}>
                        <div className="f14-500">
                          {" "}
                          {event?.viewed ? "Yes" : "No"}
                        </div>
                      </td>
                      <td style={{ width: "15%" }}>
                        <div className="f14-500">
                          {event?.used ? "Yes" : "No"}
                        </div>
                      </td>
                      <td style={{ width: "15%" }}>
                        <div className="d-flex flex-column">
                          <div className="restaurant_image_box">
                            <Image
                              src={event?.restaurant_id?.logo_url}
                              alt="Restaurant pic"
                              title="Restaurant Pic"
                              fluid
                            />
                          </div>
                          <p className="f10-500 mt-2 mb-0">
                            {event?.restaurant_id?.restaurant_name}
                          </p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                )) : <NoContent />}
            </Table>
          </div>
          {filterData && filterData.length !== 0 ? (
            <BasicPagination
              totalRecords={filterData && filterData.length}
              limit={10}
              batch={page}
              onBatchChange={(e) => handleBatchChange(e)}
            />
          ) : (
            <> </>
          )}
        </>
      ) : (
        <AmealioLoader />
      )}
    </React.Fragment>
  );
};

UserFavoritesEvents.propTypes = {
  auth: PropTypes.object.isRequired,
  getUserActivity: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  userEventActivity: state.userManagement.userEventActivity,
});

export default connect(mapStateToProps, {
  getUserActivity,
})(UserFavoritesEvents);
